// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"48":"e6aac45f","453":"5a3b85a8","472":"4418ee85","816":"e9da1877","989":"c81d6c86"}[chunkId] + ".chunk.js");